export default {
    packages_overview_title: "Package",
    packages_overview_platform: "Platform",
    packages_overview_activities: "Activities",
    packages_overview_features: "Features",
    packages_overview_assigned_to: "Assigned To",
    packages_overview_description: "Description",
}